import { CASE_ENDPOINTS } from "@/Case/config";
import { HttpClient } from "@/App/services/HttpClient";
import { handleHttpRequest } from "@/Case/services/handleHttpRequest";

type LinkToCasePayload = {
  caseId: string;
  monitorId: string;
  patientId: string;
  type: string;
};
type LinkToCaseResponse = {
  agencyId: string;
  agencyName: string;
  deviceId: string;
  monitorId: string;
  patientId: string;
  type: string;
};

const MonitorService = {
  linkToCase({ caseId, monitorId, patientId, type }: LinkToCasePayload): Promise<LinkToCaseResponse> {
    return handleHttpRequest(
      HttpClient.patch(CASE_ENDPOINTS.LINK_MONITOR(caseId, type), {
        monitorId,
        patientId,
      }),
    );
  },
};

export default MonitorService;
